export default () => {
  // Access Nuxt app and store
  const menuStore = useMenuStore()
  // Compute menus visible in the footer
  const footerMenus = computed(() => {
    return menuStore.list
      .filter((menu: Menu) => menu.show && !menu.isSubMenu)
      .flatMap((menu) => {
        if (menu.subMenu === 'gallery' && menu.subMenus) {
        // Extract valid submenus if they exist
          return menu.subMenus.filter(subMenu => subMenu.title && subMenu.slug) as Menu[]
        }
        // Otherwise, return the menu itself
        return [menu]
      })
      .filter(menu => menu.footer) // Only include menus marked for footer
  })

  // Handle cookie consent
  const showcookie = ref(false)
  onMounted(() => {
    const cookie = localStorage.getItem('cookie-accepted') || ''
    showcookie.value = cookie === ''
  })

  // PDPA info
  const pdpaStore = usePDPAStore()
  const pdpa = computed(() => pdpaStore)

  // Analytics event
  const { analyticEvent, fbPixelEvent } = useAnalytic()
  const eventFooterlink = (title: string) => {
    analyticEvent({
      ga4ActionName: 'click_footer_menu',
      ga4Label: title,
    })
    fbPixelEvent({
      fbCategory: 'trackCustom',
      fbEvent: 'Footer',
      fbValue: { label: title },
    })
  }

  return { footerMenus, eventFooterlink, showcookie, pdpa }
}
